export type YesNoDictionariesTranslation = {
  NO: string;
  YES: string;
};

export const yesNoDictionariesTranslation: YesNoDictionariesTranslation = {
  NO: 'No',
  YES: 'Yes',
};
